import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const KJRutinMeny: IRutinInfo[] = [
  rutinInfos.rtnKremationsjournal,
  rutinInfos.rtnAdresser_HarUtgatt,
  rutinInfos.rtnBegrByra,
  rutinInfos.rtnAktuellaKremationer,
  rutinInfos.rtnTvist,
  rutinInfos.rtnPostnr,
  rutinInfos.rtnOrgPersLok,
];

export default KJRutinMeny;
